import { Fragment } from "react";
import { buttonClasses } from "../../styles/buttons";

const RenderButton = ({ style, text, classes, children, onClick }) => {
    const btnClass = buttonClasses();
    classes = classes.reduce((cls, c) => cls + " " + btnClass[c], "");

    return (
        <button className={classes} style={style} value={text} onClick={() => onClick()}>
            {children}
        </button>
    );
}

export const Button = ({ style, text, classes = [], children, onClick }) => (
    <Fragment>
        <RenderButton {...{ style, text, classes: [...classes, "button", "default"], children, onClick }} />
    </Fragment>
);